import {PROJECT} from '../constants.js';

/**
 *
 * @param defaultSourceId
 */
export default function getTransactionSourceId(defaultSourceId = null) {
	return defaultSourceId ?? PROJECT.TRANSACTION.SOURCE_ID;
}
